import React, { Component } from 'react';
import { connect } from 'react-redux';
import { userAction } from '@/util/helpers/ajax-helpers';
import { MODAL_ADD_ALERT } from '../../util/enums/EnumModals';
import { buildViewChooser } from '.';
import { loadCollaborators } from '../../actions';
import { ZAPIER } from '../../util/AlertRef';

// frequency
export const DAILY = 'daily';
export const HOURLY = 'hourly';
export const FIVE_MIN = 'every 5 minutes';

// trigger
export const ALWAYS = 'always';
export const NEW_RESULTS = 'new_results';

class ModalAddAlert extends Component {
  static modalType() {
    return MODAL_ADD_ALERT;
  }

  static reducer(modals) {
    return modals.addAlertModal;
  }

  static title(state) {
    return (
      <span>
        <img src="/img/bell-icon.png" className="modal-top-icon" />
        Set up {state.triggerType === ZAPIER ? 'Zapier trigger' : 'email alert'}
      </span>
    );
  }

  static subTitle(state) {
    return state.triggerType === ZAPIER
      ? 'Set up a Zapier Trigger to automate worksflows in Zapier.'
      : 'Set up an Alert to notify you, via email, when your saved insight has new results.';
  }

  componentDidMount() {
    setTimeout(() => {
      if (this._input) {
        this._input.select();
      }
    }, 500);
    userAction('open-add-alert-modal');
  }

  alertOptions(state, userInteraction, onLoadCollaborators, isAdmin) {
    const trs = [];
    const addRow = (el) =>
      trs.push(
        <tr key={trs.length}>
          <td className="padding-top-0">{el}</td>
        </tr>,
      );

    const selectChange = (section) => (e) => {
      const props = { section, value: e.currentTarget.value };
      userInteraction(props)();
    };

    addRow(<div>&nbsp;</div>);
    addRow(
      <label>
        {state.triggerType === ZAPIER ? 'Trigger Zap on:' : 'Send email when:'}
      </label>,
    );
    addRow(
      <select
        value={state.showChanged ? 'changed' : 'new'}
        className="form-control"
        onChange={selectChange('show-changed')}
      >
        <option value="new">new rows only</option>
        <option value="changed">new or changed rows</option>
      </select>,
    );

    addRow(<div>&nbsp;</div>);
    addRow(<label>Max frequency:</label>);
    addRow(
      <select
        value={state.frequency}
        className="form-control"
        onChange={selectChange('frequency')}
      >
        <option value={DAILY}>Daily (8 am)</option>
        <option value={HOURLY}>Hourly</option>
      </select>,
    );

    if (state.triggerType !== ZAPIER) {
      addRow(<div>&nbsp;</div>);
      addRow(
        <span>
          <label>Recipients</label> (alert will be sent as email):
        </span>,
      );

      const checkboxChange = (email) => () => {
        const props = { section: 'toggleEmail', email };
        userInteraction(props)();
      };
      const recipients =
        state.allRecipients.length === 0 ? (
          <div className="subtle">No possible recipients found.</div>
        ) : (
          state.allRecipients.map((email) => {
            return (
              <div key={email}>
                <label className="user-clickable">
                  <input
                    type="checkbox"
                    checked={state.chosenRecipients.indexOf(email) > -1}
                    onChange={checkboxChange(email)}
                  />
                  <span className="padding-left-10">{email}</span>
                </label>
              </div>
            );
          })
        );
      addRow(
        <div className="margin-left-20">
          {recipients}
          <br />
          <div className="subtle">
            To add teammates to Trevor,&nbsp;
            {!isAdmin ? (
              'ask your Trevor admin'
            ) : (
              <a href="#" onClick={onLoadCollaborators}>
                click here
              </a>
            )}
            .
          </div>
        </div>,
      );
    }

    return trs;
  }

  render() {
    const { userInteraction, state, onLoadCollaborators, isAdmin } = this.props;
    const viewChooser = buildViewChooser(
      state,
      userInteraction,
      null,
      (searchBox) => (this._input = searchBox),
    );

    const trs = [];
    trs.push(
      <tr colSpan={4} key="title">
        <td>
          <label>
            {state.triggerType === ZAPIER
              ? 'Insight to load rows from:'
              : 'Insight to be alerted about:'}
          </label>
        </td>
      </tr>,
    );
    trs.push(
      <tr colSpan={4} key="chosen">
        <td>{viewChooser.chosen}</td>
      </tr>,
    );
    trs.push(
      <tr colSpan={4} key="view-options">
        <td>{viewChooser.options}</td>
      </tr>,
    );

    if (state.chosen) {
      this.alertOptions(
        state,
        userInteraction,
        onLoadCollaborators,
        isAdmin,
      ).forEach((tr) => trs.push(tr));
    }
    return (
      <table className="full-width">
        <tbody>{trs}</tbody>
      </table>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAdmin: state.datasource.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onLoadCollaborators: (e) => {
      e.preventDefault();
      dispatch(loadCollaborators());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalAddAlert);
